module.exports = __webpack_public_path__ + "media/images/icons/flags/BT-f048317452dc3c1dadf6d935259373fd.svg";